import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LogoEmblem from "@/components/LogoEmblem";

export default function Preloader() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !window.sessionStorage.getItem("nb_intro_seen");
  });

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      window.sessionStorage.setItem("nb_intro_seen", "1");
      setShow(false);
      document.body.style.overflow = "";
    }, 2600);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          exit={{ y: "-100%" }}
          transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
          data-testid="intro-overlay"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0D0F12]"
        >
          <LogoEmblem size={230} animated />
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.3, duration: 0.6 }}
            className="mt-9 font-mono text-xs uppercase tracking-[0.4em] text-slate-400"
          >
            Couvreur · Zingueur — Bordeaux
          </motion.p>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.9, ease: "easeInOut", delay: 0.4 }}
            className="mt-7 h-px w-44 origin-left bg-terra"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
